import { buildAuthHeaders } from "../forum/authHeaders";

const ROOT = "/api/home";

async function request(path = "/", { method = "GET", body, signal } = {}) {
  const response = await fetch(`${ROOT}${path}`, {
    method,
    signal,
    headers: buildAuthHeaders({
      Accept: "application/json",
      ...(body ? { "Content-Type": "application/json" } : {}),
    }),
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(
      payload?.detail || "Ton accueil ne peut pas être chargé pour le moment."
    );
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload;
}

export function loadHomeDashboard({ page = 1, pageSize = 6, signal } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  return request(`/?${params.toString()}`, { signal });
}

export function updateHomePreferences(body) {
  return request("/preferences/", { method: "PATCH", body });
}

export function resetHomePersonalization() {
  return request("/preferences/", { method: "DELETE" });
}

export function sendHomeRecommendationFeedback(id, action) {
  return request(`/recommendations/${encodeURIComponent(id)}/feedback/`, {
    method: "POST",
    body: { action },
  });
}

export function recordHomeUniverseActivity(universe, action) {
  return request(`/universes/${encodeURIComponent(universe)}/activity/`, {
    method: "POST",
    body: { action },
  });
}
